import * as Yup from 'yup';

const INITIAL_VALUES = {
  email: '',
};

const VALIDATION_SCHEMA = (pageLanguageContents) => {
  let schemaAttributes
    schemaAttributes = {
      email: Yup.string()
        .email(pageLanguageContents?.Error_Validations[0]?.Valid_Email)
        .required(pageLanguageContents?.Error_Validations[1]?.Email_Req)
        // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int|.edu|.cc|.co.uk|us){1}$/,pageLanguageContents?.Error_Validations[0]?.Valid_Email),
    };
  return Yup.object().shape(schemaAttributes);
}

export { INITIAL_VALUES, VALIDATION_SCHEMA };
